<template>
  <template>
    <Head title="Verifikation erfolgreich"/>
    <div class="min-h-screen bg-gray-50 flex justify-center items-center">
      <div class="p-6">
        <div class="w-full max-w-md">
          <logo class="block mx-auto w-full login-card__brand fill-white" height="50"/>
          <p>{{ __('auth.verified.msg') }}</p>
        </div>
      </div>
    </div>
  </template>
</template>

<script>
import {Head} from '@inertiajs/inertia-vue3'
import Logo from '@/Shared/Logo'

export default {
  components: {
    Head, Logo,
  },
}
</script>
